import type { ReactNode } from 'react';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionTitle({ title, subtitle, icon, action }: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 flex-wrap">
      <div>
        <h2 className="flex items-center gap-2 text-xl md:text-2xl font-black text-foreground-950 tracking-tight">
          {icon && (
            <span className="w-8 h-8 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center">
              <i className={`${icon} text-lg`}></i>
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}